import { Children, forwardRef, useId } from 'react';
import type { ReactNode } from 'react';
import type { WithClassName } from './types';

export type KeyValueListProps = WithClassName & {
  items: readonly { key: string; label: string; value: ReactNode; help?: string }[];
  columns?: 1 | 2;
  missingLabel?: string;
};

export const KeyValueList = forwardRef<HTMLDListElement, KeyValueListProps>(function KeyValueList({
  items, columns = 1, missingLabel = 'Not recorded', className,
}, ref) {
  const id = useId();
  return <dl ref={ref} className={`ui-key-value-list ui-key-value-list--${columns} ${className ?? ''}`}>
    {items.map((item) => {
      const helpId = `${id}-${encodeURIComponent(item.key)}-help`;
      const populated = Children.toArray(item.value).some((value) => typeof value !== 'string' || !!value.trim());
      return <div key={item.key} className="ui-key-value-list__item">
        <dt>{item.label}</dt>
        <dd aria-describedby={item.help ? helpId : undefined}>
          <div>{populated ? item.value : missingLabel}</div>
          {item.help && <div id={helpId} className="ui-key-value-list__help">{item.help}</div>}
        </dd>
      </div>;
    })}
  </dl>;
});
